module.exports = __webpack_public_path__ + "dec17751d6450e12d7138fa69773fdbf.pdf";